/**
 * KAN-713: результат проверки прокси: зелёный "Telegram доступен, IP, мс" или
 * красный текст ошибки, со временем проверки.
 */
import { checkSummary, formatCheckedAt } from '@/lib/telegramProxyDirectory';
import type { ProxyCheckResult } from '@/types/telegramProxy';

interface Props {
  result: ProxyCheckResult | null;
  testId: string;
}

export function ProxyCheckBadge({ result, testId }: Props): JSX.Element {
  if (!result) {
    return (
      <span className="text-xs text-gray-500" data-testid={testId} data-status="none">
        не проверялся
      </span>
    );
  }
  const at = formatCheckedAt(result.checked_at);
  return (
    <span
      className={`inline-flex flex-col rounded px-2 py-1 text-xs ${
        result.ok ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
      }`}
      data-testid={testId}
      data-status={result.ok ? 'ok' : 'fail'}
    >
      <span>{checkSummary(result)}</span>
      {at && <span className="text-[11px] opacity-75">{at}</span>}
    </span>
  );
}
